export interface ToastProps {
  variant: ToastVariant
  headline?: string
  description?: string
  ariaLive?: AriaLive
}

export type ToastVariant = 'success' | 'warning' | 'error' | 'info'
export type AriaLive = 'assertive' | 'polite'

export const defaultToastProps: Required<ToastProps> = {
  variant: 'success',
  headline: '',
  description: '',
  ariaLive: 'polite',
}
